export const upperCaseCode = (codeRef) => {
  const start = codeRef.current?.selectionStart;
  const end = codeRef.current?.selectionEnd;
  codeRef.current.value = codeRef.current?.value?.toUpperCase();
  codeRef.current.selectionStart = start;
  codeRef.current.selectionEnd = end;
  return codeRef.current.value;
};

export const currsorCodeIssue = (codeRef) => {
  const start = codeRef.current?.selectionStart;
  const end = codeRef.current?.selectionEnd;
  codeRef.current.value = codeRef.current?.value;
  codeRef.current.selectionStart = start;
  codeRef.current.selectionEnd = end;
  return codeRef.current.value;
};
export const upperCaseName = (codeRef) => {
  const start = codeRef.current?.selectionStart;
  const end = codeRef.current?.selectionEnd;
  codeRef.current.value = codeRef.current?.value?.toUpperCase()?.replaceAll(' ', '_');
  codeRef.current.selectionStart = start;
  codeRef.current.selectionEnd = end;
  return codeRef.current.value;
};

